/* eslint-disable class-methods-use-this */
import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { when } from "lit/directives/when.js";
import { packageButtonStyles } from "../../../styles";
import { pullRequest, branch } from "../../../svg";
import type { Package } from "../entities";

@customElement("umb-market-package-contributors")
export class UmbMarketPackageContributors extends LitElement {
  @property({ type: Object })
  package?: Package;

  #renderBadge(title: string, icon: any) {
    return html`<umb-market-button
      target="_blank"
      href=${this.package!.sourceCodeRepositoryUrl!}
    >
      <div class="btn-text">
        <span class="btn-title">${title}</span>
      </div>
      <span class="btn-icon"> ${icon}</span>
    </umb-market-button>`;
  }

  render() {
    return html`${when(this.package?.lookingForContributors, () =>
      this.#renderBadge(`Contribute to ${this.package?.title}`, pullRequest)
    )}
    ${when(this.package?.lookingForMaintainer, () =>
      this.#renderBadge(`Help maintain ${this.package?.title}`, branch)
    )}`;
  }

  static styles = [
    packageButtonStyles,
    css`
      :host {
        display: block;
        gap: var(--xs-spacer);
        justify-content: space-between;
        margin-top: var(--l-spacer);
      }

      @media (min-width: 650px) {
        :host {
          display: flex;
        }
      }

      umb-market-button {
        --button-hover-color: var(--uui-color-surface);
      }

      umb-market-button:hover {
        --button-background: var(--uui-color-current-contrast);
      }

      umb-market-button + umb-market-button {
        margin-top: 0;
      }
    `,
  ];
}
